<template>
    <div class="modal fade modal-style" id="editModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content ">
                <div class="modal-header">
					<h4 class="modal-title">{{$t('edit-stake', 'Edit Stake')}}</h4>
					<!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetChips()">&#10006;</button> -->
				</div>
                <div class="modal-body">
                    <div class="stakeed-sec withdraw-sec bg-transparent p-0 border-0 singlestakeed-sec exch-setting-edit-stack-two-divide-wrapper">
						<div class="exch-setting-edit-stack-wrapper">
							<form style="width: 100%;" v-if="stake" class="singlestake-edit-wrapper">								
                                    <div class="exch-setting-edit-stakes-input-section mobile-input" v-for="i in 4" :key="i">
                                        <input class="form-control profit-input" maxlength="8" v-model="stake[i-1]" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)">
                                    </div>
							</form>
						</div>
					</div>
                    <div class="header-but  info-footer">
						<button type="button" class="thm-but thm-bor-but" @click="resetChips()" data-bs-dismiss="modal">{{$t('cancel', 'Cancel')}}</button>
                        <a href="javascript:void(0)" class="thm-but" @click="callChangeStakeValue()">{{$t('save', 'Save')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: "EditStakeModal",
    props:['stakes'],
    data() {
        return {
            // stake: null
            stake: this.$store.getters.userTransactionStakes || this.stakes
        }
    },
    mounted() {
        this.resetChips();
    },
    methods: {
        callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast('Stake value must be between 100 to 1Cr.')
                return

            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$emit('updateStakes', { ...this.stake });
            this.$successToast('Saved Successfully')
            this.$helper.closeModal('editModal');
        },
        resetChips() {
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
        
    }
};
</script>

<style></style>